import { pathJoin } from '../utils'

export const createPrivacyPolicyRoutesMap = (prefix: string) => ({
  cookies: pathJoin(prefix)('cookies').chain,
})
